import { render, staticRenderFns } from "./AccountSend.vue?vue&type=template&id=0e1b7b0c&"
import script from "./AccountSend.vue?vue&type=script&lang=js&"
export * from "./AccountSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports